const colors = {
  navy: '#041587',
  lightBlue: '#62B4F7',
  adminBarBg: '#76b1f0'
}

export default colors
